import { Stack, Typography } from '@mui/material';
import Image from 'next/image';
import { ReactNode } from 'react';

export type ReferralQuoteProps = {
  imgSrc: string;
  children: ReactNode;
};

export function ReferralQuote({
  imgSrc,
  children
}: ReferralQuoteProps) {
  return (
  <Stack 
    direction="row" 
    alignItems="center" 
    bgcolor="background.default" 
    borderRadius="20px"
    padding="9px">
    <Image width={32} height={32} src={imgSrc} alt="Profile Picture"></Image>
    <div>
      <Typography 
        variant="body2" 
        color="text.primary" 
        fontSize="16px" 
        lineHeight="25px"
        display="inline">
        {children}
      </Typography>
    </div>
  </Stack>
  );
}